import { Question, QuestionStatus } from './../interfaces/Question';

/**
 * Function for setting different inital questions
 * used for a person that is already a member and don't need to be asked the first question
 */
export const rebaseQuestionForMember = (questions: Question[]) => {

    return questions.map((question) => {

        // Set the first question to skip
        if ( question.id === 1 ) {
            question.status = QuestionStatus.Skip
        }

        // Normally this question already have the status NotAnswered but we want to make sure
        if ( question.id === 4 ) {
            question.status = QuestionStatus.NotAnswered
        }

        return question

    })
    
}